module.exports = __webpack_public_path__ + "static/img/hotline.278acb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/tianheng/hotline.jpg
// module id = sFwM
// module chunks = 0